import { Input, Select } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import type CreditExposureCreateViewModel from "viewModels/timeCharges/distributors/creditExposures/creditExposureCreateViewModel";
import type CreditExposureDetailViewModel from "viewModels/timeCharges/distributors/creditExposures/creditExposureDetailViewModel";
import DatePickerBox from "controls/datePickerBox";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";
import { startOfEDAZDistribution } from "config";
import { addYears } from "date-fns";
import { disabledDaysRange } from "utils/dateUtils";

export interface CreditExposureFormProps {
  vm: CreditExposureCreateViewModel | CreditExposureDetailViewModel;
  children?: React.ReactNode;
}

const CreditExposureForm = observer((props: CreditExposureFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="distributorName">
          <FormLabel>{vm.translateAttribute("distributorName")}</FormLabel>
          <Input disabled={true} />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="type">
          <FormLabel>{vm.translateAttribute("type")}</FormLabel>
          <Select mode="key" items={vm.creditExposureTypeOptions} disabled={disabled} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="amount">
          <FormLabel>{vm.translateAttribute("amount")}</FormLabel>
          <Input type="number" disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="description">
          <FormLabel>{vm.translateAttribute("description")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md="6" target={vm.item} property="validSinceDate">
          <FormLabel>{vm.translateAttribute("validSinceDate")}</FormLabel>
          <DatePickerBox
            placementOverlay="top-start"
            strategyOverlay="fixed"
            fromMonth={startOfEDAZDistribution}
            toMonth={addYears(new Date(), 1)}
            disabledDays={disabledDaysRange(addYears(new Date(), 1), startOfEDAZDistribution)}
            disabled={disabled}
            placeholder={vm.translateGeneral("datepicker.format")}
          />
        </FormGroup>
        <FormGroup as={Col} md="6" target={vm.item} property="validUntilDate">
          <FormLabel>{vm.translateAttribute("validUntilDate")}</FormLabel>
          <DatePickerBox
            placementOverlay="top-start"
            strategyOverlay="fixed"
            fromMonth={new Date()}
            toMonth={addYears(new Date(), 1)}
            disabledDays={disabledDaysRange(addYears(new Date(), 1), new Date())}
            disabled={disabled}
            placeholder={vm.translateGeneral("datepicker.format")}
          />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default CreditExposureForm;
